import {createContext, useContext} from 'react'

import {noop} from '@sdox/utils'

import type {FC, PropsWithChildren, ReactNode} from 'react'
import type {DialogNewProps} from '../components/DialogNew'

export type DialogNames = 'CookiePolicy' | 'CookieConsent' | 'CookieSettings' | 'PrivacyPolicy' | string

export interface CallableDialogProps extends Omit<DialogNewProps, 'open' | 'content' | 'children' | 'onClose'> {
  content: ReactNode
  wrapper?: FC<PropsWithChildren<unknown>>
  onClose?: DialogNewProps['onClose']
}

interface IDialogContext {
  openDialog(dialog: CallableDialogProps): void
  closeDialog(): void
  openRegisteredDialog: (name: DialogNames) => void
  isDialogRegistered: (name: DialogNames) => boolean
  registerDialog: (name: DialogNames, props: CallableDialogProps) => void
  isOpen: boolean
}

export const DialogContext = createContext<IDialogContext>({
  openDialog: noop,
  closeDialog: noop,
  openRegisteredDialog: noop,
  isDialogRegistered: () => false,
  registerDialog: noop,
  isOpen: false,
})

export const useDialog = () => useContext(DialogContext)
